import Skeleton from 'react-loading-skeleton';

export default function InlineCardSkeleton({
  className = '',
  height,
}: {
  className?: string;
  height: number;
}) {
  return (
    <div
      className={` flex w-full  overflow-hidden rounded-[16px] border border-gray ${className}`}
    >
      <Skeleton width={120} height={height} containerClassName="leading-none" />
      <div className="flex flex-col gap-1.5x p-1.5x w-full min-w-0">
        <Skeleton
          width="80%"
          height={24}
          borderRadius="26px"
          inline={true}
          containerClassName="leading-none"
        />
        <div className="flex flex-col gap-x">
          <Skeleton
            width="100%"
            height={24}
            borderRadius="26px"
            containerClassName="leading-none"
          />
          <div className=" grid grid-cols-3 align-center gap-x ">
            {Array.from({ length: 3 }).map((_, index) => (
              <Skeleton
                height={24}
                borderRadius="26px"
                key={`inline-card-shimmer-${index}`}
                containerClassName="leading-none"
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
